module.exports = __webpack_public_path__ + "static/media/profit_sharing.e15be778.svg";